<div mat-dialog-title class="!flex !items-center justify-between border-b border-slate-200 pb-2 sm:pb-3 mb-3 sm:mb-4 !min-h-0">
  <h2 class="text-sm sm:text-base md:text-lg font-bold tracking-widest uppercase text-slate-800 m-0 leading-none">
    Schedule Custom SMS
  </h2>

  <button mat-icon-button (click)="onCancel()" class="!mt-0">
    <mat-icon class="text-slate-600 hover:text-slate-900">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <div class="flex flex-col gap-4">
    <!-- SMS Count -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>SMS Count</mat-label>
      <input matInput type="number" min="1" [(ngModel)]="smsCount" (ngModelChange)="onCountChange()" required
        [disabled]="isViewMode">
      <mat-error *ngIf="smsCount <= 0">Count must be greater than 0</mat-error>
    </mat-form-field>

    <!-- Dynamic Date Pickers -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-5 max-h-[60vh] sm:max-h-[300px] md:max-h-[400px] overflow-y-auto pr-1 sm:pr-2">
      <ng-container *ngFor="let date of smsDates; let i = index; trackBy: trackByIndex">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>SMS {{ i + 1 }} Date</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="smsDates[i]" required [disabled]="isViewMode">
          <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isViewMode"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="!smsDates[i]">Date is required</mat-error>
        </mat-form-field>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions
  class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 sm:gap-2 border-t border-slate-200 pt-4 sm:pt-3 mt-2 w-full">
  <button mat-button (click)="onCancel()"
    class="w-full sm:w-auto text-slate-600 uppercase text-xs font-bold tracking-wider">
    {{ isViewMode ? 'Close' : 'Cancel' }}
  </button>
  <button *ngIf="!isViewMode" mat-raised-button (click)="onSave()" [disabled]="!isValid()"
    class="w-full sm:w-auto bg-slate-900 text-white uppercase text-xs font-medium tracking-wider disabled:bg-slate-300 disabled:text-slate-500">Save</button>
</mat-dialog-actions>